import { XMarkIcon } from '@heroicons/react/24/solid';
import * as React from 'react';
import { PortCollection } from 'types/Port';

interface Props {
  portCollection: PortCollection;
  onRemove: (portCollection: PortCollection) => void;
}

export const PortPill: React.FC<Props> = (props) => {
  const { portCollection, onRemove } = props;
  const handleRemove = () => onRemove(portCollection);
  return (
    <div className="flex items-center px-3 bg-gray-100 text-gray-900 rounded-full space-x-1">
      <h3 className="font-medium">{portCollection.name}</h3>
      <XMarkIcon
        className="w-4 h-4 text-gray-500 hover:bg-gray-200 rounded-full transition cursor-pointer"
        onClick={handleRemove}
      />
    </div>
  );
};
PortPill.displayName = 'CreateCompany.CompanyDetails.PortPill';
